import { isEmpty } from "../js/tool";
import req from "../js/req";

const flagOptions = [
  { key: 1, title: "是" },
  { key: 2, title: "否" },
];

const getFlagText = (flag) => {
  let res = flagOptions.find((item) => item.key === flag);
  return res ? res.title : null;
};

export default {
  name: "阵地",
  listTitle: "阵地列表",
  url: "/position", // rest接口表名
  query: "&sort=sort,-id&expand=admin", // rest接口query参数
  // 列表渲染列
  columns: (ctx) => {
    // eslint-disable-next-line no-unused-vars
    const h = ctx.$createElement;
    return [
      { title: "阵地名称", dataIndex: "name" },
      { title: "地址", dataIndex: "address" },
      { title: "联系人", dataIndex: "user_name" },
      { title: "联系电话", dataIndex: "mobile" },
      {
        title: "是否展示名称",
        dataIndex: "is_show",
        onCell: () => {
          return {
            onClick: (e) => {
              console.log("onCell onClick");
              e.stopPropagation(); // 阻止冒泡到行
            },
          };
        },
        customRender: (text, record) => {
          // return <span>{getFlagText(text)}</span>;
          const onChange = (checked) => {
            if (record.loading) return;
            record.loading = true;
            const is_show = checked ? 1 : 2;
            req({
              url: `/position/${record.id}`,
              method: "PATCH",
              data: {
                id: record.id,
                is_show,
              },
            })
              .then(() => {
                record.is_show = is_show;
                ctx.$message.success("更新成功");
              })
              .finally(() => {
                record.loading = false;
              });
          };
          const checked = record.is_show === 1;
          return (
            <a-switch
              checked={checked}
              onChange={onChange}
              onClick={(checked, e) => e.stopPropagation()}
              onMousedown={(e) => e.stopPropagation()}
              onMouseup={(e) => e.stopPropagation()}
            />
          );
        },
      },
      { title: "排序", dataIndex: "sort" },
    ];
  },
  searchKeyType: {
    name: 1,
    keyword: function(form, key) {
      let res = "";
      const value = form[key];
      if (!isEmpty(value)) {
        res = `&filter[or][0][user_name][like]=${value}&filter[or][1][mobile][like]=${value}`;
      }
      return res;
    },
  },
  // 列表查询表单
  queryForm: [
    {
      key: "name",
      label: "",
      component: "a-input",
      props: {
        placeholder: "请输入阵地名称搜索",
        allowClear: true,
      },
      style: { width: "240px" },
    },
    {
      key: "keyword",
      label: "",
      component: "a-input",
      props: {
        placeholder: "请输入联系人姓名、电话搜索",
        allowClear: true,
      },
      style: { width: "240px" },
    },
    {
      key: "is_show",
      label: "",
      component: "a-select",
      props: {
        options: flagOptions,
        allowClear: true,
        placeholder: "请选择是否展示名称搜索",
      },
      style: { width: "240px" },
    },
  ],
  // 新增/编辑查询表单
  items: [
    {
      key: "name",
      label: "阵地名称",
      component: "a-input",
      props: {
        placeholder: "请输入阵地名称",
      },
      rules: [{ required: true, message: "请输入阵地名称", trigger: "blur" }],
    },
    {
      key: "logo",
      label: "阵地logo",
      component: "form-upload",
      props: {
        limit: 1,
      },
      rules: [{ required: false, message: "请上传阵地logo", trigger: "change" }],
    },
    {
      key: "location",
      label: "阵地地址",
      component: "coordinate-picker",
      rules: [{ required: true, message: "请选择地址", trigger: "change" }],
    },
    {
      key: "user_name",
      label: "联系人",
      component: "a-input",
      props: {
        placeholder: "请输入联系人",
      },
      rules: [{ required: false, message: "请输入联系人", trigger: "blur" }],
    },
    {
      key: "mobile",
      label: "联系电话",
      component: "a-input",
      props: {
        placeholder: "请输入联系电话",
      },
      rules: [{ required: false, message: "请输入联系电话", trigger: "blur" }],
    },
    {
      key: "introduction",
      label: "阵地简介",
      component: "a-textarea",
      props: {
        placeholder: "请输入阵地简介",
        rows: 4,
      },
      rules: [{ required: false, message: "请输入阵地简介", trigger: "blur" }],
    },
    {
      key: "honor",
      label: "阵地荣誉",
      component: "a-textarea",
      props: {
        placeholder: "请输入阵地荣誉",
        rows: 4,
      },
      rules: [{ required: false, message: "请输入阵地荣誉", trigger: "blur" }],
    },
    {
      key: "is_show",
      label: "是否展示名称",
      component: "a-switch",
      props: {},
      rules: [{ required: true, message: "请选择是否展示", trigger: "change" }],
    },
    {
      key: "sort",
      label: "排序",
      component: "a-input-number",
      props: {
        placeholder: "数字越小排位越前",
      },
      style: {
        width: "240px",
      },
    },
  ],
  // 详情接口expand字段
  expand: "?expand=admin",
  init: { price: 0 }, // 新增实体初始化字段
  // 详情渲染字段
  renderItems: (ctx) => {
    // eslint-disable-next-line no-unused-vars
    const h = ctx.$createElement;
    return [
      { label: "阵地名称", key: "name" },
      { label: "阵地logo", key: "logo", img: true },
      { label: "地址", key: "address" },
      { label: "联系人", key: "user_name" },
      { label: "联系电话", key: "mobile" },
      { label: "阵地简介", key: "introduction" },
      { label: "阵地荣誉", key: "honor" },
      { label: "是否展示名称", key: "is_show", slot: (entity) => <span>{getFlagText(entity.is_show)}</span> },
      { label: "排序", key: "sort" },
    ];
  },
  // 详情渲染字段
  beforeEdit: function(detail) {
    return new Promise((resolve) => {
      if (detail.lat_lon && detail.name && detail.address) {
        detail.location = {
          latLng: detail.lat_lon,
          name: detail.address_name,
          address: detail.address,
        };
      }
      detail.is_show = detail.is_show === 1;
      resolve(detail);
    });
  },
  beforeUpdate: function(form) {
    return new Promise((resolve) => {
      if (form.location) {
        form.lat_lon = form.location.latLng;
        form.address_name = form.location.name;
        form.address = form.location.address;
      }
      form.is_show = form.is_show ? 1 : 2;
      resolve(form);
    });
  },
};
